export const slugs = {
  mwjp: {
      ouiSommesNous: 'company-information',
      commentCaMarche: 'how-to-access',
      mentionsLegales: 'legal-information',
      viePrivee: 'private-life',
      cookies: 'cookies'
  },
  mljp: {
      ouiSommesNous: 'company-information',
      commentCaMarche: 'how-to-access',
      mentionsLegales: 'legal-information',
      viePrivee: 'private-life',
      cookies: 'cookies'
  },
  playbacpresse: {
      ouiSommesNous: 'qui-sommes-nous',
      commentCaMarche: 'comment-ca-marche',
      mentionsLegales: 'mentions-legales',
      viePrivee: 'vie-privee',
      cookies: 'cookies'
  },
  mwde: {
      ouiSommesNous: 'uber-uns',
      commentCaMarche: 'und-so-gehts',
      mentionsLegales: 'impressum',
      viePrivee: 'privatsphare',
      cookies: 'cookies'
  },
  mlde: {
      ouiSommesNous: 'uber-uns',
      commentCaMarche: 'und-so-gehts',
      mentionsLegales: 'impressum',
      viePrivee: 'privatsphare',
      cookies: 'cookies'
  },
  clfy: {
      ouiSommesNous: 'who-are-we-clarify',
      commentCaMarche: 'how-does-clarify-work',
      mentionsLegales: 'legal-notices',
      viePrivee: 'private-life',
      cookies: 'cookies'
  }
};
